import { createFileRoute } from '@tanstack/react-router';

import { requirePermission } from '@/app/guards';
import { RolesPage } from '@/features/admin';

export const Route = createFileRoute('/_app/admin/roles/')({
  staticData: { crumb: 'admin:nav.roles' },
  beforeLoad: ({ context }) => requirePermission(context.queryClient, 'admin.roles', 'Setup'),
  component: RolesPage,
});
